export default {
    notifications: null,
    refresh: true
}